/* NUVO Animations v2 — scroll reveals, count-up, cursor glow, header */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mensajes de interfaz por idioma (html lang: en/es/fr — lo pone Shopify por locale) */
  var NUVO_LANG = (document.documentElement.lang || 'en').slice(0, 2);
  var NUVO_MSG = {
    en: { size: '✦ Pick your size first', email: "✦ Enter a valid email and we'll keep you posted.", add: "Couldn't add the product. Please try again." },
    es: { size: '✦ Elige tu talla primero', email: '✦ Escribe un email válido y te avisamos.', add: 'No se ha podido añadir el producto. Inténtalo de nuevo.' },
    fr: { size: "✦ Choisissez d'abord votre taille", email: "✦ Saisissez un email valide et on vous tient au courant.", add: "Impossible d'ajouter le produit. Réessayez." }
  };
  var NUVO_T = NUVO_MSG[NUVO_LANG] || NUVO_MSG.en;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* -------------------------------------------------------
     R6 (02/09/2026) · Pastillas estilo Apple
     - [data-nuvo-live]: «N personas viendo». N es SIMULADO (decisión de
       FOXMILLO): arranca según la hora (más gente por la tarde-noche), se
       guarda en sessionStorage para que todas las páginas digan lo mismo y
       cada 4-11 s se mueve ±1-3 dentro de [data-min, data-max].
     - [data-nuvo-timer]: cuenta atrás hasta las 23:59:59 locales (la «oferta
       de hoy»); todas las instancias comparten el mismo reloj.
  ------------------------------------------------------- */
  function initSocialProof() {
    var lives = document.querySelectorAll('[data-nuvo-live]');
    if (lives.length) {
      var min = parseInt(lives[0].getAttribute('data-min') || '6', 10) || 6;
      var max = parseInt(lives[0].getAttribute('data-max') || '40', 10) || 40;
      if (max < min) { max = min + 5; }
      var key = 'nuvo_live_n', n = 0;
      try {
        var st = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (st && st.n && (Date.now() - st.t) < 20 * 60000) { n = st.n; }
      } catch (e) {}
      if (!n) {
        var h = new Date().getHours();
        var curve = (h >= 19 && h <= 23) ? 1 : (h >= 12 && h < 19) ? 0.72 : (h >= 8 && h < 12) ? 0.5 : 0.25;
        n = Math.round(min + (max - min) * (0.3 + 0.55 * curve) + (Math.random() * 6 - 3));
      }
      function clamp(v) { return Math.max(min, Math.min(max, v)); }
      n = clamp(n);
      function paint() {
        lives.forEach(function (el) {
          var b = el.querySelector('[data-live-n]');
          if (!b) { return; }
          b.textContent = String(n);
          b.classList.remove('is-tick'); void b.offsetWidth; b.classList.add('is-tick');
        });
        try { sessionStorage.setItem(key, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {}
      }
      paint();
      (function tick() {
        setTimeout(function () {
          if (!document.hidden) {
            var d = Math.floor(Math.random() * 5) - 2;
            if (!d) { d = Math.random() < 0.5 ? -1 : 1; }
            n = clamp(n + d);
            paint();
          }
          tick();
        }, 4000 + Math.random() * 7000);
      })();
    }
    var timers = document.querySelectorAll('[data-nuvo-timer]');
    if (timers.length) {
      var pad = function (x) { return (x < 10 ? '0' : '') + x; };
      var paintT = function () {
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
        var sLeft = Math.max(0, Math.floor((end - now) / 1000));
        var t = pad(Math.floor(sLeft / 3600)) + ':' + pad(Math.floor((sLeft % 3600) / 60)) + ':' + pad(sLeft % 60);
        timers.forEach(function (el) {
          var b = el.querySelector('[data-timer-val]');
          if (b && b.textContent !== t) { b.textContent = t; }
        });
      };
      paintT();
      setInterval(paintT, 1000);
    }
  }

  /* -------------------------------------------------------
     Scroll reveals — elementos con clase .nuvo-reveal
  ------------------------------------------------------- */
  function initReveals() {
    if (prefersReduced) return;
    if (!('IntersectionObserver' in window)) return;

    var els = document.querySelectorAll('.nuvo-reveal');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.delay || '0', 10);
        setTimeout(function () { el.classList.add('nuvo-visible'); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------
     Count-up — elementos con clase .nuvo-count + data-target
  ------------------------------------------------------- */
  function initCountUp() {
    if (prefersReduced) return;
    if (!('IntersectionObserver' in window)) return;

    var counts = document.querySelectorAll('.nuvo-count');
    if (!counts.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.target) || 0;
        var duration = 1800;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var elapsed = ts - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(eased * target);
          el.textContent = value.toLocaleString('es-ES');
          if (progress < 1) { requestAnimationFrame(step); }
        }

        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });

    counts.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------
     Cursor glow — sigue el ratón en el hero
  ------------------------------------------------------- */
  function initCursorGlow() {
    var glow = document.querySelector('.nuvo-cursor-glow');
    if (!glow) return;

    var raf = null;
    var mx = -999, my = -999;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!raf) {
        raf = requestAnimationFrame(function () {
          glow.style.left = mx + 'px';
          glow.style.top  = my + 'px';
          raf = null;
        });
      }
    });
  }

  /* -------------------------------------------------------
     Header scrolled — glassmorphism al hacer scroll
  ------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 40) { header.classList.add('nuvo-scrolled'); }
      else { header.classList.remove('nuvo-scrolled'); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------
     Parallax suave en el hero blob
  ------------------------------------------------------- */
  function initParallax() {
    if (prefersReduced) return;
    var blob = document.querySelector('.nuvo-hero__blob');
    if (!blob) return;

    var raf = null;
    window.addEventListener('scroll', function () {
      if (!raf) {
        raf = requestAnimationFrame(function () {
          var y = window.scrollY * 0.2;
          blob.style.transform = 'translateY(' + y + 'px)';
          raf = null;
        });
      }
    }, { passive: true });
  }

  /* -------------------------------------------------------
     Parallax en la imagen de fondo del hero (ref. Space Tumbler)
  ------------------------------------------------------- */
  function initHeroImageParallax() {
    if (prefersReduced) return;
    var bg = document.querySelector('.nuvo-slider__bg');
    if (!bg) return;

    var raf = null;
    window.addEventListener('scroll', function () {
      if (!raf) {
        raf = requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight * 1.2) {
            bg.style.transform = 'translateY(' + (y * 0.35) + 'px)';
          }
          raf = null;
        });
      }
    }, { passive: true });
  }

  /* -------------------------------------------------------
     Sticky ATC — ocultar mientras el botón principal esté a la vista
     (evita el "Añadir al carrito" duplicado)
  ------------------------------------------------------- */
  function initStickyAtcDedupe() {
    var main = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');
    var sticky = document.querySelector('sticky-atc, .sticky-atc');
    if (!main || !sticky || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('nuvo-sticky-hide', entry.isIntersecting);
      });
    }, { threshold: 0.12 });
    io.observe(main);
  }

  /* -------------------------------------------------------
     Pop del contador del carrito al cambiar la cantidad
  ------------------------------------------------------- */
  function initCartPulse() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono || !('MutationObserver' in window)) { return; }
    var mo = new MutationObserver(function () {
      var burbuja = icono.querySelector('.cart-count-bubble');
      if (!burbuja) { return; }
      burbuja.classList.remove('nuvo-pop');
      void burbuja.offsetWidth;
      burbuja.classList.add('nuvo-pop');
    });
    mo.observe(icono, { childList: true, subtree: true, characterData: true });
  }

  /* §01 Hero logo-intro: la lógica vive INLINE en la sección
     nuvo-hero-intro (autocontenida, sin depender de este asset). */

  /* -------------------------------------------------------
     §02 Producto — galería (flechas/puntitos), variantes,
     Comprar ahora (→ checkout), chispa ✦ y barra ATC pegajosa.
  ------------------------------------------------------- */
  function initProduct() {
    var section = document.querySelector('[data-nuvo-product]');
    if (!section) return;

    /* 🩹 Red de seguridad de la reserva del pin (CLS, 14/08): si algo revienta más
       abajo en esta función, el hueco reservado se quedaría para siempre (150svh de
       vacío bajo el producto). Con esto se suelta igualmente a los 4 s. */
    setTimeout(function () { document.documentElement.classList.add('nuvo-pin-ready'); }, 4000);

    /* Galería swipe + flechas + puntitos */
    var gallery = section.querySelector('[data-gallery]');
    var dots = section.querySelectorAll('[data-dot]');
    var prevBtn = section.querySelector('[data-prev]');
    var nextBtn = section.querySelector('[data-next]');
    function slideW() {
      var sl = gallery && gallery.querySelector('.nuvo-p__slide');
      return sl ? sl.getBoundingClientRect().width : (gallery ? gallery.clientWidth : 0);
    }
    if (gallery) {
      if (prevBtn) { prevBtn.addEventListener('click', function () { gallery.scrollBy({ left: -slideW(), behavior: 'smooth' }); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { gallery.scrollBy({ left: slideW(), behavior: 'smooth' }); }); }
      if (dots.length) {
        dots.forEach(function (d) {
          d.addEventListener('click', function () {
            var i = parseInt(d.getAttribute('data-dot'), 10) || 0;
            gallery.scrollTo({ left: slideW() * i, behavior: 'smooth' });
          });
        });
        var galRaf = null;
        gallery.addEventListener('scroll', function () {
          if (galRaf) { return; }
          galRaf = requestAnimationFrame(function () {
            galRaf = null;
            var i = Math.round(gallery.scrollLeft / Math.max(slideW(), 1));
            dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
          });
        }, { passive: true });
      }
    }

    /* Variantes */
    var idInput = section.querySelector('.nuvo-p__variant-id');
    var priceEl = section.querySelector('[data-price]');
    var cmpEl = section.querySelector('[data-compare]');
    var savEl = section.querySelector('[data-save]');
    var atcPrice = section.querySelector('[data-atc-price]');
    var curLabel = section.querySelector('[data-variant-current]');
    var addBtn = section.querySelector('[data-add]');
    var buyBtn = section.querySelector('[data-buy-now]');
    var pills = section.querySelectorAll('.nuvo-p__pill');

    /* TALLA OBLIGATORIA (07/08): la §02 ya no preselecciona talla — hay que ELEGIR
       antes de comprar. Con 1 sola variante (sin pills) o con una ya activa (ficha
       PDP) no se exige nada. */
    var chosen = pills.length === 0 || !!section.querySelector('.nuvo-p__pill.is-active');
    var chooseHint = section.querySelector('[data-choose-hint]');
    var pillsWrap = section.querySelector('[data-pills]');
    var morphST = null;          /* ScrollTrigger del morph §02→barra (se asigna al crear la timeline) */
    var pendingNudge = false;    /* sacudida DIFERIDA hasta que el morph se deshaga y las pills se vean */
    function nudgePills() {
      if (chooseHint) { chooseHint.textContent = NUVO_T.size; }
      if (pillsWrap) {
        pillsWrap.classList.remove('is-nudge');
        void pillsWrap.offsetWidth;
        pillsWrap.classList.add('is-nudge');
      }
    }
    function needsChoice(desdeBarra) {
      if (chosen) { return false; }
      if (!desdeBarra) { nudgePills(); return true; }
      /* Desde la barra pegajosa: TOAST + VUELTA LIMPIA a la §02 (09/08). Con el pin
         de GSAP, scrollIntoView era un no-op (el producto está fixed durante el pin)
         o aterrizaba al FINAL del pin con todo fundido → hay que ir al píxel exacto
         donde el morph está a 0 (st.start); la sacudida de las pills se difiere al
         onUpdate (progress<0.05), cuando ya son visibles. */
      var toast = document.querySelector('.nuvo-atc__toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'nuvo-atc__toast';
        document.body.appendChild(toast);
      }
      toast.textContent = NUVO_T.size;
      toast.classList.add('is-on');
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2400);
      if (morphST) {
        pendingNudge = true;
        window.scrollTo({ top: morphST.start, behavior: 'smooth' });
      } else {
        var sec = document.getElementById('producto');
        if (sec) { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        setTimeout(nudgePills, 550);
      }
      return true;
    }

    /* Selector de CANTIDAD (07/08): junto al precio; alimenta el form de añadir
       (input name=quantity) y el "Comprar ahora". */
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyVal = section.querySelector('[data-qval]');
    function currentQty() { return Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1); }
    function setQty(n) {
      n = Math.min(99, Math.max(1, n));
      if (qtyInput) { qtyInput.value = String(n); }
      if (qtyVal) { qtyVal.textContent = String(n); }
    }
    var qMinus = section.querySelector('[data-qminus]');
    var qPlus = section.querySelector('[data-qplus]');
    /* refreshAtc() recalcula TAMBIÉN el precio grande (unitario × cantidad − volumen) */
    if (qMinus) { qMinus.addEventListener('click', function () { setQty(currentQty() - 1); refreshAtc(); }); }
    if (qPlus) { qPlus.addEventListener('click', function () { setQty(currentQty() + 1); refreshAtc(); }); }

    /* La BARRA pegajosa refleja la elección (talla × cantidad y el TOTAL del set):
       "Size 1 × 3" + precio unitario×cantidad (pedido 07/08). */
    var atcSel = section.querySelector('[data-atc-sel]');
    var curCents = 0, curTitle = '', curCmpCents = 0;

    /* FORMATO DE MONEDA heredado de Shopify (11/08): fmtEur tenía el «€» detrás
       fijo, así que al recalcular por cantidad el precio pasaba de «€20,90» a
       «39,71 €» — y en un mercado con dólares habría escrito euros. Ahora se
       aprende del primer render (prefijo, sufijo y separador decimal), que ya
       viene en la moneda del visitante. */
    var mPre = '', mPost = ' €', mDec = ',';
    (function () {
      var t = ((priceEl && priceEl.textContent) || '').trim();
      var m = t.match(/^(\D*)([\d.,\s]+?)(\D*)$/);
      if (!m) { return; }
      mPre = m[1]; mPost = m[3];
      var num = m[2];
      var lastC = num.lastIndexOf(','), lastP = num.lastIndexOf('.');
      mDec = lastC > lastP ? ',' : (lastP > -1 ? '.' : ',');
    })();
    function fmtEur(cents) { return mPre + (cents / 100).toFixed(2).replace('.', mDec) + mPost; }

    /* ────────────────────────────────────────────────────────────────
       PRECIO POR VOLUMEN (11/08/2026)
       Dos cosas que pidió FOXMILLO:
         1. el precio que se ve MULTIPLICA por la cantidad (antes se quedaba
            clavado en el unitario aunque eligieras 3);
         2. a más unidades, más % de descuento.
       ⚠️ El % que se PINTA tiene que existir de verdad en el checkout: los
       tramos se corresponden con DESCUENTOS AUTOMÁTICOS creados en la tienda
       (mínimo de cantidad). Pintar un descuento que luego no se aplica es
       publicidad engañosa — y el cliente lo ve al pagar.
       Los tramos vienen del markup: [data-vol] con data-tiers="2:5,3:10,4:15".
       Sin ese nodo, todo se comporta como antes (molde limpio).
       ──────────────────────────────────────────────────────────────── */
    var volEl = section.querySelector('[data-vol]');
    var volTiers = [];
    if (volEl) {
      volTiers = (volEl.getAttribute('data-tiers') || '').split(',').map(function (t) {
        var p = t.split(':');
        return { min: parseInt(p[0], 10) || 0, pct: parseFloat(p[1]) || 0 };
      }).filter(function (t) { return t.min > 1 && t.pct > 0; })
        .sort(function (a, b) { return a.min - b.min; });
    }
    function volPct(q) {
      var pct = 0;
      volTiers.forEach(function (t) { if (q >= t.min) { pct = t.pct; } });
      return pct;
    }
    function pintaTramos(q) {
      if (!volEl) { return; }
      var activo = volPct(q);
      volEl.querySelectorAll('[data-tier]').forEach(function (el) {
        var min = parseInt(el.getAttribute('data-tier'), 10) || 0;
        el.classList.toggle('is-on', q >= min);
        el.classList.toggle('is-next', !activo ? min === volTiers[0].min : (min > q && !el.classList.contains('is-on')));
      });
    }

    /* Precio mostrado = unitario × cantidad − descuento por volumen.
       El tachado y el −X% se calculan sobre el compare-at × cantidad, así que
       el porcentaje que se ve es el AHORRO TOTAL real frente al precio tachado. */
    function refreshPrecio() {
      if (!priceEl || !curCents) { return; }
      var q = currentQty();
      var pct = volPct(q);
      /* v1.2 (23/09): se redondea POR UNIDAD y luego se multiplica, que es como descuenta
         Shopify en el carrito. Redondeando el total, la ficha decía 49,99 y el carrito
         cobraba 50,00 en la oferta de 2 del pijama. */
      var total = q * Math.round(curCents * (1 - pct / 100));
      priceEl.textContent = fmtEur(total);
      if (curCmpCents) {
        var totalCmp = curCmpCents * q;
        if (cmpEl) { cmpEl.textContent = fmtEur(totalCmp); }
        if (savEl) { savEl.textContent = '-' + Math.round((1 - total / totalCmp) * 100) + '%'; }
      } else if (pct && savEl) {
        savEl.textContent = '-' + pct + '%';
        savEl.classList.remove('is-off');
        savEl.removeAttribute('hidden');
      }
      pintaTramos(q);
    }

    function refreshAtc() {
      var q = currentQty();
      if (atcSel) {
        atcSel.textContent = curTitle ? (' · ' + curTitle + (q > 1 ? ' × ' + q : '')) : (q > 1 ? ' · × ' + q : '');
      }
      if (atcPrice && curCents) {
        atcPrice.textContent = fmtEur(q * Math.round(curCents * (1 - volPct(q) / 100)));
      }
      refreshPrecio();
    }

    /* GEOMETRÍA RESERVADA del precio (10/08): tachado y -X% entraban/salían del
       flujo con `hidden` y los flex centrados re-repartían el ancho → el precio
       "se movía solo" al cambiar de talla (y en pantallas estrechas la fila hacía
       wrap/des-wrap). Pasada única: se mide el ancho MÁXIMO de cada hueco entre
       todas las variantes y se clava con minWidth; si ALGUNA variante tiene rebaja,
       tachado y badge quedan SIEMPRE en flujo y alternan visibility (.is-off).
       Sin rebajas (caso actual de las botas) no se reserva hueco muerto. */
    var anyCompare = false;
    (function () {
      if (!priceEl || !pills.length) { return; }
      var keepP = priceEl.textContent;
      var keepC = cmpEl ? cmpEl.textContent : '';
      var keepS = savEl ? savEl.textContent : '';
      var hadHiddenC = cmpEl ? cmpEl.hasAttribute('hidden') : true;
      var hadHiddenS = savEl ? savEl.hasAttribute('hidden') : true;
      var wP = priceEl.offsetWidth || 0, wC = 0, wS = 0;
      pills.forEach(function (p) {
        var pr = p.getAttribute('data-variant-price') || '';
        var cm = p.getAttribute('data-variant-compare') || '';
        var sv = p.getAttribute('data-variant-save') || '';
        if (cm || sv) { anyCompare = true; }
        if (pr) { priceEl.textContent = pr; if (priceEl.offsetWidth > wP) { wP = priceEl.offsetWidth; } }
        if (cmpEl && cm) { cmpEl.removeAttribute('hidden'); cmpEl.textContent = cm; if (cmpEl.offsetWidth > wC) { wC = cmpEl.offsetWidth; } }
        if (savEl && sv) { savEl.removeAttribute('hidden'); savEl.textContent = '-' + sv + '%'; if (savEl.offsetWidth > wS) { wS = savEl.offsetWidth; } }
      });
      priceEl.textContent = keepP;
      if (wP) { priceEl.style.minWidth = wP + 'px'; }
      if (cmpEl) { cmpEl.textContent = keepC; }
      if (savEl) { savEl.textContent = keepS; }
      if (anyCompare) {
        if (cmpEl) { cmpEl.style.minWidth = wC + 'px'; cmpEl.removeAttribute('hidden'); cmpEl.classList.toggle('is-off', hadHiddenC || !keepC); }
        if (savEl) { savEl.style.minWidth = wS + 'px'; savEl.removeAttribute('hidden'); savEl.classList.toggle('is-off', hadHiddenS || !keepS); }
      } else {
        if (cmpEl && hadHiddenC) { cmpEl.setAttribute('hidden', ''); }
        if (savEl && hadHiddenS) { savEl.setAttribute('hidden', ''); }
      }
    })();

    /* Semilla del precio: sin tocar ninguna pill, curCents venía a 0 y el precio
       no reaccionaba al stepper. Se toma de la variante activa (PDP) o de la
       primera (§02, donde aún no hay talla elegida pero todas valen igual). */
    (function () {
      var base = section.querySelector('.nuvo-p__pill.is-active') || pills[0];
      if (base) {
        curCents = parseInt(base.getAttribute('data-variant-cents') || '0', 10) || 0;
        curCmpCents = parseInt(base.getAttribute('data-variant-compare-cents') || '0', 10) || 0;
      } else if (priceEl) {
        var n = (priceEl.textContent || '').replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
        curCents = Math.round(parseFloat(n) * 100) || 0;
      }
      if (volEl) { pintaTramos(currentQty()); }
    })();

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        chosen = true;
        if (chooseHint) { chooseHint.textContent = ''; }
        var available = pill.getAttribute('data-available') === 'true';
        if (idInput) { idInput.value = pill.getAttribute('data-variant-id'); }
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var price = pill.getAttribute('data-variant-price');
        if (priceEl && price) { priceEl.textContent = price; }
        if (atcPrice && price) { atcPrice.textContent = price; }
        /* Tachado y -X% de ESTA variante (antes se quedaban los de la inicial =
           dato de rebaja falso; auditoría 07/08). Sin rebaja → ocultos. */
        var cmp = pill.getAttribute('data-variant-compare') || '';
        var sav = pill.getAttribute('data-variant-save') || '';
        /* Con rebajas en alguna variante: alternar VISIBILITY (.is-off) — el hueco
           está reservado y nada se mueve. Sin rebajas: hidden como siempre. */
        if (cmpEl) {
          cmpEl.textContent = cmp;
          if (anyCompare) { cmpEl.classList.toggle('is-off', !cmp); }
          else if (cmp) { cmpEl.removeAttribute('hidden'); }
          else { cmpEl.setAttribute('hidden', ''); }
        }
        if (savEl) {
          savEl.textContent = sav ? ('-' + sav + '%') : '';
          if (anyCompare) { savEl.classList.toggle('is-off', !sav); }
          else if (sav) { savEl.removeAttribute('hidden'); }
          else { savEl.setAttribute('hidden', ''); }
        }
        if (curLabel) { curLabel.textContent = pill.getAttribute('data-variant-title'); }
        curTitle = pill.getAttribute('data-variant-title') || '';
        curCents = parseInt(pill.getAttribute('data-variant-cents') || '0', 10) || 0;
        curCmpCents = parseInt(pill.getAttribute('data-variant-compare-cents') || '0', 10) || 0;
        refreshAtc();
        if (addBtn) { addBtn.disabled = !available; }
        if (buyBtn) { buyBtn.disabled = !available; }
        /* El input oculto name="id" TAMBIÉN: Liquid lo renderiza disabled si la variante
           inicial está agotada, y FormData EXCLUYE los inputs disabled → el POST a
           /cart/add salía SIN id y "Añadir" fallaba en silencio (auditoría 07/08). */
        if (idInput) { idInput.disabled = !available; }
        /* La barra pegajosa refleja el agotado (su botón proxya a estos) */
        var atcProxy = document.querySelector('.nuvo-atc [data-atc-buy], .nuvo-atc [data-atc-add]');
        if (atcProxy) { atcProxy.disabled = !available; }
      });
    });

    /* Chispa ✦ que vuela al carrito */
    function spark(x, y) {
      if (prefersReduced) { return; }
      var cart = document.getElementById('cart-icon-bubble');
      var tx = window.innerWidth - 42, ty = 42;
      if (cart) { var cr = cart.getBoundingClientRect(); tx = cr.left + cr.width / 2; ty = cr.top + cr.height / 2; }
      var el = document.createElement('div');
      el.className = 'nuvo-spark';
      el.textContent = '✦';
      /* offset = mitad de los 44px de la chispa (tamaño del icono del carrito) */
      el.style.left = (x - 22) + 'px';
      el.style.top = (y - 22) + 'px';
      el.style.transition = 'transform 1.6s cubic-bezier(0.5,0,0.2,1), opacity 1.6s ease';
      document.body.appendChild(el);
      void el.offsetWidth;
      el.style.transform = 'translate(' + (tx - x) + 'px,' + (ty - y) + 'px) scale(0.35)';
      el.style.opacity = '0';
      setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 1700);
    }

    /* 🛡 Protección de envío (14/08): checkbox opt-in bajo las tallas (snippet
       nuvo-prot-check). Marcada → la protección entra en el carrito ANTES del
       add/checkout vía /cart/update.js con cantidad ABSOLUTA 1 (idempotente:
       aunque ya estuviera, nunca se duplica el cargo). Desmarcada NO quita nada:
       quitar se hace en la línea del carrito, donde se ve lo que hay. */
    /* v1.3g (26/09): las casillas son dos (protección y envío prioritario): van
       las marcadas, juntas, en un solo /cart/update.js */
    var protChecks = section.querySelectorAll('[data-prot-check]');
    function protMarcada() {
      return Array.prototype.some.call(protChecks, function (c) { return c.checked; });
    }
    function protEnsure() {
      if (!protMarcada()) { return Promise.resolve(); }
      var upd = {};
      Array.prototype.forEach.call(protChecks, function (c) {
        if (c.checked) { upd[c.getAttribute('data-prot-id')] = 1; }
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: upd })
      }).catch(function () {});
    }

    /* Comprar ahora → añade y va al checkout. OJO: fetch NO rechaza con HTTP 422
       (variante agotada en carrera, tope de stock) → hay que mirar r.ok, si no el
       cliente aterrizaba en el checkout SIN el producto (auditoría 07/08). */
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        if (needsChoice(!e || !e.isTrusted)) { return; }
        var id = idInput ? idInput.value : null;
        if (!id) { return; }
        buyBtn.disabled = true;
        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        protEnsure().then(function () {
          return fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: currentQty() }] })
          });
        }).then(function (r) {
          if (!r.ok) { return r.json().then(function (j) { throw j; }); }
          window.location.href = '/checkout';
        }).catch(function (err) {
          buyBtn.disabled = false;
          var wrapErr = section.querySelector('.product-form__error-message-wrapper');
          if (wrapErr) {
            var msg = wrapErr.querySelector('.product-form__error-message');
            if (msg) { msg.textContent = (err && err.description) ? err.description : NUVO_T.add; }
            wrapErr.removeAttribute('hidden');
          }
        });
      });
    }

    /* Chispa al añadir (el add real lo gestiona product-form de Dawn) */
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        /* Sin talla elegida NO se añade: preventDefault frena el submit del form */
        if (needsChoice(!e.isTrusted)) { e.preventDefault(); e.stopPropagation(); return; }
        /* 🛡 Protección marcada: primero la protección al carrito, LUEGO el submit
           real. requestSubmit dispara el evento submit (lo captura product-form de
           Dawn = add AJAX + cajón) sin volver a pasar por este click (14/08). */
        if (protMarcada()) {
          e.preventDefault(); e.stopPropagation();
          var px = e.clientX, py = e.clientY, pTrusted = e.isTrusted;
          protEnsure().then(function () {
            if (pTrusted) { spark(px || (window.innerWidth / 2), py || (window.innerHeight / 2)); }
            var pform = section.querySelector('.nuvo-p__atc-form');
            if (pform && pform.requestSubmit) { pform.requestSubmit(addBtn); }
          });
          return;
        }
        /* Solo la chispa del clic REAL en el botón; nada de chispa desde el centro
           cuando el clic es programático (barra ATC). */
        if (!e.isTrusted) { return; }
        spark(e.clientX || (window.innerWidth / 2), e.clientY || (window.innerHeight / 2));
      });
    }

    /* SCROLL-MOTION §02 → barra: la sección se queda CLAVADA (pin) y el scroll la
       APLASTA hacia abajo —ancho completo, perdiendo altura— hasta quedar convertida
       en la barra de compra; solo entonces entra la §03 y la barra queda fija. Al
       subir, se deshace (scrub reversible). Detrás asoma el vídeo del hero (cortina).
       Coreografía: el CONTENIDO se funde al empezar (no se deforma), el PANEL se
       aplasta hacia el borde inferior, y al final hay fundido cruzado panel→barra.
       Motor = GSAP ScrollTrigger pin+scrub (doctrina §10). Fallback sin GSAP /
       reduced-motion = aparición simple por IntersectionObserver. */
    var atc = section.querySelector('[data-atc]');
    var actions = section.querySelector('.nuvo-p__actions');
    var pwrap = section.querySelector('.nuvo-p__wrap');
    var pbg = section.querySelector('[data-p-bg]');
    /* El wrapper de sección (y el pin-spacer que GSAP le mete dentro) también deben
       soltar los toques: un div TRANSPARENTE sigue capturando el hit-testing, y con
       pointer-events:none solo en #producto el clic moría en sus ancestros → el
       logo/carrito del hero se VEÍAN pero no se podían tocar (feedback 09/08). */
    var pwrapSection = section.closest('.nuvo-p-section') || section.parentElement;
    if (atc && actions) {
      /* Sácala del flujo → viewport-fija de verdad (que ningún ancestro la atrape). */
      if (atc.parentNode !== document.body) { document.body.appendChild(atc); }
      /* Marca de que ESTA página lleva barra pegajosa: el CSS del footer reserva sitio
         para que la fila inferior (idiomas, cookies, legales) no quede debajo de ella. */
      document.body.classList.add('nuvo-has-atc');

      /* Botones de la barra: [data-atc-buy] (§02 → checkout exprés) y
         [data-atc-add] (ficha PDP → añadir con chispa, como el botón real). */
      var atcBuy = atc.querySelector('[data-atc-buy]');
      if (atcBuy && buyBtn) { atcBuy.addEventListener('click', function () { buyBtn.click(); }); }
      var atcAdd = atc.querySelector('[data-atc-add]');
      if (atcAdd && addBtn) {
        atcAdd.addEventListener('click', function (e) {
          if (addBtn.disabled) { return; }   /* agotado: sin chispa de "éxito" falsa */
          spark(e.clientX, e.clientY); addBtn.click();
        });
      }

      var setAtcState = function (on) {
        atc.style.pointerEvents = on ? 'auto' : 'none';
        atc.setAttribute('aria-hidden', on ? 'false' : 'true');
      };

      /* 🎃 SIN MORPH (26/08, pedido de FOXMILLO): fuera el pin+scrub de GSAP que
         aplastaba la §02 hasta convertirla en la barra (GSAP ya ni se carga en
         theme.liquid). La barra de compra pegajosa va SOLO por
         IntersectionObserver: aparece cuando el bloque de compra sale por ARRIBA
         y se esconde al volver a la sección. El ascenso del panel sobre el hero
         (cortina) es scroll nativo y sigue intacto. La llave de abajo deja el
         bloque del morph muerto pero recuperable desde el git del molde. */
      var NUVO_MORPH_OFF = true;
      var G = window.gsap, ST = window.ScrollTrigger;
      if (!NUVO_MORPH_OFF && G && ST && pwrap && pbg && !prefersReduced) {
        G.registerPlugin(ST);
        /* Móvil: ignorar el resize de la barra de direcciones (recalculaba el pin
           en pleno scroll = tirones). */
        ST.config({ ignoreMobileResize: true });
        /* normalizeScroll QUITADO (07/08): en iOS congelaba la página ENTERA ~3s tras
           scrolls rápidos con cambio de dirección (visto en vídeo del usuario) — al
           normalizar, el scroll depende del hilo JS y cualquier atasco lo clava todo.
           Mejor un pelín de jitter del pin que congelones. */
        atc.style.transition = 'none';   /* la opacidad/posición de la barra la lleva GSAP */
        /* 📱 FLUIDEZ (15/08, orden de FOXMILLO «si no va bien, se quita»): en móvil la
           marca de agua del morph NO se anima — su contra-escalado corre en CADA
           fotograma sobre una capa de 130vh con patrón rotado (lo más caro de toda la
           timeline en GPUs de teléfono). pwm=null la salta entera (el tl.fromTo y el
           G.set del onUpdate van con if(pwm)). En PC se queda como siempre. */
        var pwm = window.matchMedia('(max-width: 749px)').matches ? null : section.querySelector('[data-p-wm]');
        var pmedia = section.querySelector('.nuvo-p__media');
        var pinfo = section.querySelector('.nuvo-p__info');
        var docked = false;
        var tl = G.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: section,
            pin: true,
            anticipatePin: 1,         /* elimina el saltito al entrar en el pin */
            start: 'bottom bottom',   /* cuando ya se ha visto el producto ENTERO */
            end: '+=200%',            /* 150→200 (16/08, pedido de FOXMILLO): más tiempo
                                         CLAVADA en ambos sentidos — la zona muerta pasa
                                         de ~48vh a ~80vh de scroll tranquilo.
                                         ⚠️ Este número y el 200svh de la RESERVA anti-CLS
                                         de nuvo-custom.css son EL MISMO: tocar los dos. */
            /* Suavizado por dispositivo (16/08): en táctil 0.55→0.4 — con más
               interpolación la página seguía moviéndose tras soltar el dedo y los
               micro-toques se sentían como tirones (vídeo de FOXMILLO). */
            scrub: (ST.isTouch === 1 ? 0.4 : 0.45),
            /* CLAVADO SIMÉTRICO con HISTÉRESIS direccional (08/08): si el scroll muere
               dentro de la zona del pin, la página se asienta sola — pero el GESTO manda:
               bajando favorece ACOPLAR la barra (corte 0.38) y subiendo favorece DESHACER
               el morph hacia el producto entero (corte 0.62). Antes el corte era 0.5 fijo
               y al subir despacio te podía devolver a la barra contra tu intención. */
            snap: {
              snapTo: function (value, self) {
                var dir = (self && self.direction) || 1;
                /* Cortes 0.45/0.60 (16/08): con el recorrido a 200% los viejos 0.38/0.62
                   devolvían al usuario demasiado atrás en píxeles reales. */
                var cut = dir < 0 ? 0.6 : 0.45;
                return value < cut ? 0 : 1;
              },
              duration: { min: 0.25, max: 0.6 },
              delay: 0.1,
              ease: 'power2.out'
            },
            invalidateOnRefresh: true,
            onUpdate: function (self) {
              setAtcState(self.progress > 0.78);
              /* Toda la §02 deja PASAR los toques con el contenido fundido: el hero
                 (y su CARRITO) se ven de fondo y deben poder tocarse — la sección
                 transparente capturaba los toques y el carrito no se podía abrir
                 (feedback 07/08). 09/08: el none va en el WRAPPER de sección (lo
                 heredan el pin-spacer de GSAP y #producto); con el none solo en
                 #producto los ancestros transparentes seguían comiéndose el clic. */
              if (pwrapSection) { pwrapSection.style.pointerEvents = self.progress > 0.45 ? 'none' : ''; }
              /* Vuelta desde la barra sin talla: sacudir las pills JUSTO cuando el
                 morph se ha deshecho y ya son visibles (09/08). */
              if (pendingNudge && self.progress < 0.05) { pendingNudge = false; nudgePills(); }
              /* Chispa ✦ del botón: pop de celebración justo cuando la barra se ACOPLA */
              var d = self.progress > 0.88;
              if (d !== docked) { docked = d; atc.classList.toggle('is-docked', d); }
              /* CONTRA-ESCALADO de la marca de agua: cada fotograma la capa se
                 estira 1/escala del panel → el patrón NUVO nunca se deforma con
                 el aplastamiento, solo se recorta su ventana. */
              if (pwm) {
                var s = G.getProperty(pbg, 'scaleY') || 1;
                G.set(pwm, { scaleY: 1 / s });
              }
            }
          }
        });
        morphST = tl.scrollTrigger;   /* needsChoice vuelve al píxel de progress 0 */

        /* 🛡 CENTINELA ANTI-ATASCO (16/08): en el webview de Facebook/Instagram los
           micro-toques interrumpen el snap de ScrollTrigger y la página se QUEDABA a
           medio morph (panel en blanco / contenido fantasma — vídeo de FOXMILLO).
           Respaldo de un solo dueño: si el scroll lleva 700ms muerto (el snap normal
           ya habría terminado) y el progreso sigue a medias, se remata solo hacia el
           ancla que tocaría según el sentido del gesto. Solo en táctil. */
        if (ST.isTouch === 1) {
          var settleT = null;
          var settleWatch = function () {
            clearTimeout(settleT);
            settleT = setTimeout(function () {
              var st = tl.scrollTrigger;
              if (!st || !st.isActive) { return; }
              var p = st.progress;
              if (p > 0.04 && p < 0.96) {
                var cut = (st.direction || 1) < 0 ? 0.6 : 0.45;
                window.scrollTo({ top: p < cut ? st.start : st.end, behavior: 'smooth' });
              }
            }, 700);
          };
          window.addEventListener('scroll', settleWatch, { passive: true });
          window.addEventListener('touchend', settleWatch, { passive: true });
        }
        /* 0 → 0.32: ZONA MUERTA — la sección aguanta clavada para dar tiempo a
           "Comprar ahora"/"Añadir al carrito". Con una RESPIRACIÓN sutil (0.985):
           feedback táctil de que el scroll está "cargando" el morph, sin molestar.
           Coreografía v4.2: respiración → disolución en cascada → panel comprimiendo
           con marca de agua → la barra sube y se ACOPLA con pop de chispa ✦. */
        /* 0.06→0.12 (10/08): colchón real en el reposo del snap — con la respiración
           pegada al progress 0, un micro-scroll tras tocar una pill ya "movía" la
           columna entera (el precio parecía animarse solo). */
        tl.to(pwrap, { scale: 0.985, y: 5, transformOrigin: '50% 100%', duration: 0.24, ease: 'none' }, 0.12);
        /* Coreografía v4.3 (07/08): el contenido se va DEL TODO antes de que la marca
           de agua asome — antes se solapaban y la foto medio-transparente con NUVOs
           detrás quedaba SUCIA (captura del usuario). Fases SECUENCIALES limpias. */
        /* EASES SIMÉTRICOS (08/08): un tramo scrubbeado se recorre en AMBOS sentidos;
           las curvas *.out se convertían en *.in al subir (el contenido "explotaba"
           tarde y seco al deshacer el morph). sine.inOut es la MISMA curva ida y
           vuelta → bajar y subir se sienten igual de fluidos. */
        /* RE-FASADO 16/08 (vídeo de FOXMILLO): con las fases estrictamente secuenciales,
           un descanso entre el fundido y la compresión enseñaba un PANEL EN BLANCO a
           pantalla completa (contenido a 0, panel entero). Ahora el fundido va más
           tarde y más corto, y la compresión ARRANCA casi a la vez → cualquier punto
           intermedio enseña un panel ya comprimiéndose, nunca un vacío estático.
           (El remate lo pone el centinela anti-atasco de abajo.)
           Con el recorrido a 200%, la zona muerta 0→0.40 son ~80vh de scroll quieto. */
        /* 1) El conjunto se recoge y el contenido se disuelve (foto → textos) */
        tl.to(pwrap, { scale: 0.96, y: 14, transformOrigin: '50% 100%', duration: 0.24, ease: 'power1.inOut' }, 0.40);
        if (pmedia && pinfo) {
          tl.to(pmedia, { opacity: 0, duration: 0.12, ease: 'sine.inOut' }, 0.42);
          tl.to(pinfo,  { opacity: 0, duration: 0.12, ease: 'sine.inOut' }, 0.45);
        } else {
          tl.to(pwrap, { opacity: 0, duration: 0.12, ease: 'sine.inOut' }, 0.43);
        }
        /* 2) Marca de agua (solo PC) + compresión del panel, SOLAPADA con el final
           del fundido para que no exista un fotograma de panel entero vacío. */
        if (pwm) { tl.fromTo(pwm, { opacity: 0 }, { opacity: 1, duration: 0.14, ease: 'sine.inOut' }, 0.54); }
        tl.fromTo(pbg, { scaleY: 1 }, {
          scaleY: function () {
            var h = pbg.offsetHeight || 1;
            return Math.max((atc.offsetHeight || 70) / h, 0.02);
          },
          transformOrigin: '50% 100%',
          duration: 0.34,
          ease: 'sine.inOut'
        }, 0.54);
        /* 3) La barra ASCIENDE desde abajo y se acopla sobre el panel comprimiéndose */
        tl.fromTo(atc,
          { yPercent: 110, y: 0 },   /* y:0 anula el translateY(110%) del CSS base */
          { yPercent: 0, duration: 0.24, ease: 'sine.inOut' }, 0.66);
        /* 4) El panel entrega el relevo bajo la barra y desaparece */
        tl.to(pbg, { opacity: 0, duration: 0.1 }, 0.88);
        /* Capas COMPUESTAS de antemano (08/08): sin force3D, el navegador móvil
           promociona/des-promociona capas en pleno scroll = micro-tirones. */
        G.set([pwrap, pbg, atc], { force3D: true });
        if (pmedia) { G.set(pmedia, { willChange: 'opacity' }); }
        if (pinfo) { G.set(pinfo, { willChange: 'opacity' }); }
        /* 0.9 → 1: margen de asiento antes de soltar el pin */
        setAtcState(false);
      } else if ('IntersectionObserver' in window) {
        var atcIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            atc.classList.toggle('is-on', passed);
            atc.classList.toggle('is-docked', passed);   /* pop de la chispa ✦ al acoplarse */
            setAtcState(passed);
          });
        }, { threshold: 0 });
        atcIO.observe(actions);
      }
    }

    /* 🩹 CLS (14/08): soltar la RESERVA del hueco del pin (ver nuvo-custom.css).
       Va aquí, al final de initProduct y en el MISMO tick en que ScrollTrigger ha
       creado su .pin-spacer: el navegador no llega a pintar el estado intermedio,
       así que el cambio neto de layout es 0 px y no hay salto.
       Cubre TODOS los caminos (con GSAP, sin GSAP, reduced-motion, sin barra). */
    document.documentElement.classList.add('nuvo-pin-ready');
  }

  /* -------------------------------------------------------
     §03 Vídeos — coverflow CIRCULAR infinito (central + vecinos
     atenuados sin blur). Flecha B + swipe + click para centrar.
     Solo transform + opacity. El central reproduce al estar a la vista.
  ------------------------------------------------------- */
  function initVideos() {
    var section = document.querySelector('[data-nuvo-videos]');
    if (!section) { return; }
    var stage = section.querySelector('[data-stage]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-slide]'));
    var n = slides.length;
    if (!n) { return; }
    var current = 0;
    var playing = false;

    function config() {
      var vw = window.innerWidth;
      if (window.matchMedia('(min-width: 990px)').matches) {
        return { maxRel: 2, off1: 250, off2: 470, sc1: 0.8, sc2: 0.62, op1: 0.55, op2: 0.3 };
      }
      return { maxRel: 1, off1: vw * 0.44, off2: vw * 0.9, sc1: 0.8, sc2: 0.6, op1: 0.5, op2: 0 };
    }
    function relOf(i) {
      var rel = i - current;
      if (rel > n / 2) { rel -= n; }
      if (rel < -n / 2) { rel += n; }
      return rel;
    }
    function render() {
      var c = config();
      slides.forEach(function (slide, i) {
        var rel = relOf(i);
        var abs = Math.abs(rel);
        var x = 0, sc = 0.62, op = 0, z = 0, hidden = true;
        if (abs === 0) { sc = 1; op = 1; z = 5; hidden = false; }
        else if (abs === 1) { x = rel < 0 ? -c.off1 : c.off1; sc = c.sc1; op = c.op1; z = 3; hidden = false; }
        else if (abs === 2 && c.maxRel >= 2) { x = rel < 0 ? -c.off2 : c.off2; sc = c.sc2; op = c.op2; z = 1; hidden = false; }
        slide.style.transform = 'translateX(' + x + 'px) scale(' + sc + ')';
        slide.style.opacity = op;
        slide.style.zIndex = z;
        slide.setAttribute('data-hidden', hidden ? 'true' : 'false');
        slide.setAttribute('data-center', abs === 0 ? 'true' : 'false');
        var v = slide.querySelector('video');
        if (v) {
          if (abs === 0 && playing) { v.play().catch(function () {}); }
          else if (abs !== 0) { v.pause(); }
        }
      });
    }
    function go(dir) { current = (current + dir + n) % n; render(); }

    var prevBtn = section.querySelector('[data-vprev]');
    var nextBtn = section.querySelector('[data-vnext]');
    if (prevBtn) { prevBtn.addEventListener('click', function () { go(-1); }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { go(1); }); }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (relOf(i) === 0) {
          var v = slide.querySelector('video');
          if (v) { if (v.paused) { v.play().catch(function () {}); } else { v.pause(); } }
        } else { current = i; render(); }
      });
    });

    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx == null) { return; }
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); }
      sx = null;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { playing = entry.isIntersecting; render(); });
      }, { threshold: 0.4 });
      io.observe(section);
    } else { playing = true; }

    var vRaf = null;
    window.addEventListener('resize', function () {
      if (vRaf) { return; }
      vRaf = requestAnimationFrame(function () { vRaf = null; render(); });
    }, { passive: true });
    render();
  }

  /* -------------------------------------------------------
     §05 Lema con ruleta — palabra que rota y aterriza en NUVO arcoíris.
  ------------------------------------------------------- */
  function initSlogan() {
    var rot = document.querySelector('[data-rot]');
    if (!rot) { return; }
    var wordEl = rot.querySelector('[data-word]');
    if (!wordEl) { return; }
    var words = (rot.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    var brand = rot.getAttribute('data-brand') || 'NUVO';
    var seq = words.concat([brand]);
    if (seq.length < 2) { return; }
    var i = 0;

    // Ancho fijo del hueco = palabra más larga → "Make your life" no se mueve al rotar.
    /* 09/08: en PC el hueco fijo dejaba AIRE MUERTO a la derecha con palabras cortas
       (NUVO) y la línea centrada por text-align quedaba corrida a la izquierda
       (maxW-w)/2 px. Compensación: translateX animado de la LÍNEA entera por palabra
       (solo ≥990px; doctrina "solo transform+opacity"). */
    var centerLine = function () {};
    (function () {
      var lineEl = rot.closest('.nuvo-l__line');
      var widths = {};
      var maxW = 0;
      var lastTarget = null;   /* palabra OBJETIVO del giro en vuelo: permite centrar
                                  ANTES del swap de texto (10/08) y blinda re-mediciones */
      var measureRot = function () {
        var current = wordEl.textContent;
        maxW = 0;
        seq.forEach(function (w) {
          wordEl.textContent = w;
          widths[w] = wordEl.offsetWidth;
          if (widths[w] > maxW) { maxW = widths[w]; }
        });
        wordEl.textContent = current;
        if (maxW) { rot.style.minWidth = maxW + 'px'; }
        centerLine();
      };
      centerLine = function (targetWord) {
        if (!lineEl) { return; }
        if (targetWord) { lastTarget = targetWord; }
        if (window.matchMedia('(min-width: 990px)').matches) {
          var word = lastTarget || wordEl.textContent;
          var w = widths[word] || maxW;
          lineEl.style.transform = 'translateX(' + ((maxW - w) / 2).toFixed(1) + 'px)';
        } else {
          lineEl.style.transform = '';
        }
      };
      /* PC (1 línea): palabra a la IZQUIERDA para seguir la frase. MÓVIL (la palabra va
         en su propia línea): CENTRADA — a la izquierda quedaba descolgada (feedback 06/08). */
      var alignRot = function () {
        rot.style.textAlign = window.matchMedia('(min-width: 990px)').matches ? 'left' : 'center';
      };
      measureRot();
      alignRot();
      /* Primer render SIN deslizamiento: la posición inicial se aplica seca
         (la transition de .nuvo-l__line haría planear la línea al cargar). */
      if (lineEl) {
        lineEl.style.transition = 'none';
        void lineEl.offsetWidth;
        lineEl.style.transition = '';
      }
      /* Re-medir con la FUENTE REAL ya cargada y al cambiar el viewport (el clamp del
         font-size cambia el ancho → el hueco se quedaba mal medido; auditoría 07/08). */
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(measureRot);
      }
      var rzT = null;
      window.addEventListener('resize', function () {
        alignRot();
        centerLine();
        if (rzT) { clearTimeout(rzT); }
        rzT = setTimeout(measureRot, 150);
      }, { passive: true });
    })();

    if (prefersReduced) {
      setInterval(function () {
        i = (i + 1) % seq.length;
        wordEl.textContent = seq[i];
        wordEl.classList.toggle('nuvo-rainbow-text', seq[i] === brand);
        centerLine();
      }, 1900);
      return;
    }

    /* La ruleta DUERME fuera de vista (perf 60Hz): el bucle de giros solo corre
       con la sección en pantalla; al volver, se reanuda. */
    var rotVisible = true;
    var rotTimer = null;
    function schedule() {
      if (!rotVisible) { return; }
      if (rotTimer) { clearTimeout(rotTimer); }
      rotTimer = setTimeout(tick, seq[i] === brand ? 1700 : 1350);
    }
    function tick() {
      if (!rotVisible) { return; }
      /* 10/08: la línea arranca su re-centrado YA, con la palabra vieja saliendo
         (sus 0.65s cubren salida 0.3s + entrada 0.4s) — antes esperaba al swap y
         los 127px de viaje se comprimían en la ventana de la entrada = tirón. */
      centerLine(seq[(i + 1) % seq.length]);
      wordEl.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
      wordEl.style.transform = 'translateY(-60%)';
      wordEl.style.opacity = '0';
      setTimeout(function () {
        i = (i + 1) % seq.length;
        wordEl.textContent = seq[i];
        wordEl.classList.toggle('nuvo-rainbow-text', seq[i] === brand);
        wordEl.style.transition = 'none';
        wordEl.style.transform = 'translateY(60%)';
        wordEl.style.opacity = '0';
        void wordEl.offsetWidth;
        wordEl.style.transition = 'transform 0.4s cubic-bezier(0.16,1,0.3,1), opacity 0.35s ease';
        wordEl.style.transform = 'translateY(0)';
        wordEl.style.opacity = '1';
        schedule();
      }, 300);
    }
    if ('IntersectionObserver' in window) {
      var rotSec = rot.closest('section') || rot;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var was = rotVisible; rotVisible = e.isIntersecting;
          if (rotVisible && !was) { schedule(); }
        });
      }, { threshold: 0 }).observe(rotSec);
    }
    schedule();
  }

  /* -------------------------------------------------------
     §06 Universo — overlay Available Soon + validación de email
     integrada (sin tooltip del navegador). También valida el Club (§07).
  ------------------------------------------------------- */
  function initUniverse() {
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    document.querySelectorAll('[data-universe-email]').forEach(function (input) {
      var form = input.closest('form');
      if (!form) { return; }
      var hint = form.querySelector('[data-universe-hint]');
      form.addEventListener('submit', function (e) {
        if (!EMAIL.test((input.value || '').trim())) {
          e.preventDefault();
          input.classList.add('is-invalid');
          if (hint) { hint.textContent = NUVO_T.email; }
          input.focus();
        }
      });
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (hint) { hint.textContent = ''; }
      });
    });

    var section = document.querySelector('[data-nuvo-universe]');
    if (section) {
      var openEl = section.querySelector('[data-universe-open]');
      var overlay = section.querySelector('[data-universe-overlay]');
      /* El overlay se MUEVE a <body>: dentro del footer caía en el contexto de
         apilamiento de .nuvo-u (z-index 1) y el contenido del footer se pintaba
         POR ENCIMA al abrirlo (bug "se solapa con el footer"). En <body> su
         z-index es global y tapa la página entera, como debe. */
      if (overlay && overlay.parentNode !== document.body) { document.body.appendChild(overlay); }
      var closeEl = overlay ? overlay.querySelector('[data-universe-close]') : null;
      var lastFocus = null;
      var open = function () {
        if (!overlay) { return; }
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        /* Gestión de foco del diálogo: entrar al abrir, volver al cerrar (a11y) */
        lastFocus = document.activeElement;
        var focusTarget = overlay.querySelector('[data-universe-email]') || closeEl;
        if (focusTarget && focusTarget.focus) { focusTarget.focus(); }
      };
      var close = function () {
        if (!overlay) { return; }
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
      };
      if (openEl) {
        openEl.addEventListener('click', open);
        openEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      }
      if (closeEl) { closeEl.addEventListener('click', close); }
      if (overlay) { overlay.addEventListener('click', function (e) { if (e.target === overlay) { close(); } }); }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
      /* Enlaces "Universo NUVO" (nav del hero, footer…) abren la pantalla del universo */
      document.querySelectorAll('[data-universe-nav]').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      /* Llegada directa con #universo (footer de otra página o return_to del form) → abrir.
         OJO auditoría 07/08: el "éxito" de form 'customer' es GLOBAL en Shopify — abrir el
         overlay solo por [data-universe-success] lo disparaba también al apuntarse al CLUB
         del footer (secuestraba la pantalla). Ahora cada form lleva su return_to y solo
         el hash #universo abre. */
      if (window.location.hash === '#universo') { open(); }
    }

    /* Vuelta del alta del CLUB (10/08): Shopify redirige a /#club-ok — bajar suave
       hasta el club para que el "✓ Welcome to the Club!" se VEA (antes aterrizaba
       en el hero y el éxito quedaba 4 pantallas más abajo). El scroll va por JS con
       retardo: el pin de GSAP de la §02 mete un spacer de +150% y el salto de ancla
       nativo aterrizaría corrido. Fallback al footer si el club va oculto (móvil). */
    if (window.location.hash === '#club-ok') {
      setTimeout(function () {
        var clubBox = document.querySelector('.nuvo-f__club');
        var target = (clubBox && clubBox.offsetParent) ? clubBox : document.querySelector('.nuvo-f');
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }, 250);
    }

    document.querySelectorAll('[data-cookie-prefs]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* 10/08: banner NATIVO de Shopify (el propio se retiró — salían dos).
           privacyBanner.showPreferences() reabre su modal de preferencias. */
        try {
          if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
            window.privacyBanner.showPreferences();
            return;
          }
        } catch (e) {}
        try {
          if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.openConsentBanner === 'function') {
            Shopify.customerPrivacy.openConsentBanner();
            return;
          }
        } catch (e2) {}
        /* Última red: el banner propio, si algún día se restaura en theme.liquid */
        window.dispatchEvent(new CustomEvent('nuvo:cookie-prefs'));
      });
    });
  }

  /* -------------------------------------------------------
     Cabecera pegajosa (home): aparece al pasar el hero. Logo→inicio
     + carrito que abre el cajón de Dawn; contador sincronizado.
  ------------------------------------------------------- */
  function initStickyHeader() {
    var sticky = document.querySelector('[data-sticky-header]');
    var hero = document.querySelector('[data-nuvo-hero-intro]');
    if (!sticky || !hero) { return; }

    /* La APARICIÓN la gobierna initPerfPausing con su señal "past" (la ruleta tapa
       el hero): un IO sobre el hero NO puede funcionar aquí — el hero es sticky
       full-scroll y nunca deja de intersectar (09/08). */

    /* Fuera del stacking context del hero (z-index 0): a <body>, como la barra ATC */
    if (sticky.parentNode !== document.body) { document.body.appendChild(sticky); }

    var logo = sticky.querySelector('[data-sticky-logo]');
    if (logo) {
      logo.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    /* El logo del hero también: en la home, volver arriba suave en vez de recargar */
    var heroLogo = document.querySelector('[data-hero-logo]');
    if (heroLogo) {
      heroLogo.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    var cart = sticky.querySelector('[data-sticky-cart]');
    if (cart) {
      cart.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(cart); }
      });
    }

    var count = sticky.querySelector('[data-sticky-count]');
    var source = document.getElementById('cart-icon-bubble');
    function sync() {
      var bubble = source ? source.querySelector('.cart-count-bubble span[aria-hidden]') : null;
      var nTxt = bubble ? bubble.textContent.trim() : '';
      if (count) { count.textContent = nTxt; count.classList.toggle('is-on', !!nTxt); }
    }
    sync();
    if (source && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
    }
  }

  /* -------------------------------------------------------
     §04 Reseñas — cinta que se AUTO-MUEVE y además es DESLIZABLE
     con el dedo (scroll nativo) en ambos sentidos, en bucle infinito.
  ------------------------------------------------------- */
  function initReviews() {
    var vp = document.querySelector('[data-nuvo-reviews] .nuvo-r__viewport');
    if (!vp) { return; }
    var track = vp.querySelector('.nuvo-r__track');
    if (!track) { return; }
    var seg = 0;
    var dragging = false;
    function measure() { seg = track.scrollWidth / 3; if (seg && vp.scrollLeft < 1) { vp.scrollLeft = seg; } }
    measure();
    window.addEventListener('resize', function () { requestAnimationFrame(measure); }, { passive: true });

    /* Bucle infinito cuando mueve EL USUARIO (swipe móvil / arrastre PC / trackpad) */
    function wrapManual() {
      if (!seg) { return; }
      if (vp.scrollLeft >= seg * 2) { vp.scrollLeft -= seg; }
      else if (vp.scrollLeft < seg) { vp.scrollLeft += seg; }
    }

    var paused = false, resumeT = null;
    function pause() { paused = true; if (resumeT) { clearTimeout(resumeT); } }
    function resumeLater() { if (resumeT) { clearTimeout(resumeT); } resumeT = setTimeout(function () { paused = false; }, 1400); }
    vp.addEventListener('mouseenter', pause);
    vp.addEventListener('mouseleave', function () { if (!dragging) { resumeLater(); } });
    vp.addEventListener('touchstart', pause, { passive: true });
    vp.addEventListener('touchend', resumeLater, { passive: true });
    vp.addEventListener('scroll', function () { if (paused) { wrapManual(); } }, { passive: true });

    /* Arrastre con RATÓN en ordenador (el táctil del móvil ya es scroll nativo) */
    var dragX = 0, dragFrom = 0;
    vp.addEventListener('mousedown', function (e) {
      dragging = true; dragX = e.clientX; dragFrom = vp.scrollLeft;
      pause(); vp.classList.add('is-dragging'); e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) { return; }
      vp.scrollLeft = dragFrom - (e.clientX - dragX);
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) { return; }
      dragging = false; vp.classList.remove('is-dragging'); resumeLater();
    });
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Auto-movimiento con acumulador DECIMAL: sumar 0.4 directo a scrollLeft se
       redondeaba a 0 en muchas pantallas (scrollLeft va a píxel entero) y la
       cinta se quedaba QUIETA — por eso "no se movían solas".
       El bucle rAF SOLO corre con la cinta a la vista (auditoría 07/08: escribir
       scrollLeft cada fotograma toda la sesión = CPU/batería y TBT regalados). */
    var pos = null;
    var speed = prefersReduced ? 0 : 0.5;
    var rafId = null;
    function loop() {
      if (!paused && seg && speed) {
        if (pos === null) { pos = vp.scrollLeft; }
        pos += speed;
        if (pos >= seg * 2) { pos -= seg; }
        else if (pos < seg) { pos += seg; }
        vp.scrollLeft = pos;
      } else { pos = null; /* re-sincroniza tras tocar/arrastrar el usuario */ }
      rafId = requestAnimationFrame(loop);
    }
    function startLoop() { if (rafId === null) { pos = null; rafId = requestAnimationFrame(loop); } }
    function stopLoop() { if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; } }
    if ('IntersectionObserver' in window) {
      var secR = document.querySelector('[data-nuvo-reviews]') || vp;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { startLoop(); } else { stopLoop(); } });
      }, { threshold: 0 }).observe(secR);
    } else { startLoop(); }
  }

  /* -------------------------------------------------------
     Footer — NUVO gigante ENCAJADO al ancho en móvil (08/08).
     El clamp por vw se pasaba un pelo y la O se cortaba por la derecha
     (además el tracking negativo deja el último glifo FUERA de su caja).
     Aquí se MIDE el texto renderizado y se ajusta el font-size para que
     ocupe el ancho completo de pantalla sin cortarse por ningún extremo.
     Solo <990px: en PC el tamaño con margen es diseño cerrado (ronda 5C).
  ------------------------------------------------------- */
  function initFooterWordmark() {
    var wm = document.querySelector('.nuvo-f__wordmark');
    var txt = wm ? wm.querySelector('[data-wordmark-fit]') : null;
    if (!wm || !txt) { return; }
    var fit = function () {
      /* clientWidth y no innerWidth: la barra de scroll no cuenta como ancho útil */
      var vw = document.documentElement.clientWidth || window.innerWidth;
      if (!vw) { return; }
      if (vw >= 990) { wm.style.fontSize = ''; return; }
      wm.style.fontSize = '';                       /* base CSS limpia para medir */
      var base = parseFloat(getComputedStyle(wm).fontSize) || 10;
      var w = txt.getBoundingClientRect().width;
      if (!w) { return; }
      var target = vw - 4;                          /* 2px de aire por lado */
      wm.style.fontSize = (base * target / w).toFixed(2) + 'px';
      /* pasada fina por si el motor de texto no escala 100% lineal */
      var w2 = txt.getBoundingClientRect().width;
      if (w2 > target) {
        wm.style.fontSize = (parseFloat(wm.style.fontSize) * target / w2).toFixed(2) + 'px';
      }
    };
    fit();
    /* Re-encajar con la FUENTE REAL cargada y al girar/redimensionar */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(fit);
    }
    var t = null;
    window.addEventListener('resize', function () {
      if (t) { clearTimeout(t); }
      t = setTimeout(fit, 120);
    }, { passive: true });
  }

  /* -------------------------------------------------------
     Pausas de rendimiento (auditoría 07/08):
     - El vídeo del hero es STICKY: seguía decodificándose detrás del contenido
       durante TODO el scroll → se pausa al dejar el hero atrás y se reanuda al volver.
     - Las auroras del footer solo animan con el footer A LA VISTA (clase is-inview).
  ------------------------------------------------------- */
  function initPerfPausing() {
    var video = document.querySelector('.nuvo-hi__video');
    var hero = document.querySelector('[data-nuvo-hero-intro]');
    if (video || hero) {
      var vpRaf = null;
      var slogan = document.querySelector('[data-nuvo-slogan]');
      var stickyHdr = document.querySelector('[data-sticky-header]');
      window.addEventListener('scroll', function () {
        if (vpRaf) { return; }
        vpRaf = requestAnimationFrame(function () {
          vpRaf = null;
          /* El hero es el TELÓN visible durante todo el morph de la §02 (el producto
             debe SEGUIR girando de fondo — feedback 07/08): solo está "pasado" cuando
             la ruleta (§03, primera sección opaca tras la §02) lo tapa por completo. */
          var past = slogan
            ? slogan.getBoundingClientRect().top <= 0
            : window.scrollY > window.innerHeight * 1.15;
          /* Hero TAPADO (es sticky, queda detrás de las secciones): sus arcoíris
             animados dejan de repintar — el IO no sirve aquí porque "intersecta"
             aunque esté cubierto. */
          if (hero) { hero.classList.toggle('nuvo-hi--covered', past); }
          /* La mini-cabecera pegajosa entra EXACTAMENTE cuando el hero deja de
             verse (misma señal): logo→inicio + carrito clicables el resto del
             scroll (09/08; era el rojo pre-lanzamiento de la auditoría §9). */
          if (stickyHdr) { stickyHdr.classList.toggle('is-on', past); }
          if (video) {
            if (past && !video.paused) { video.pause(); }
            else if (!past && video.paused) {
              var p = video.play();
              if (p && p.catch) { p.catch(function () {}); }
            }
          }
        });
      }, { passive: true });
    }
    /* Arcoíris animados (background-position = REPINTA cada fotograma): pausados
       fuera de pantalla. Cubre también los hilos ::before/::after de la barra. */
    if ('IntersectionObserver' in window) {
      var shiny = document.querySelectorAll('.nuvo-rainbow-text, .nuvo-rainbow-bg, .nuvo-atc');
      if (shiny.length) {
        var rio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.target.classList.toggle('nuvo-rainbow-off', !e.isIntersecting); });
        }, { threshold: 0 });
        shiny.forEach(function (el) { rio.observe(el); });
      }
    }
    var foot = document.querySelector('.nuvo-f');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { foot.classList.toggle('is-inview', e.isIntersecting); });
      }, { threshold: 0 }).observe(foot);
    } else if (foot) { foot.classList.add('is-inview'); }
  }

  /* -------------------------------------------------------
     🧸 Muñequitos decorativos ([data-deco]) — reveal al entrar
     en pantalla, una sola vez. Baratísimo: IO + una clase;
     el balanceo es CSS puro (transform) y reduced-motion lo apaga.
  ------------------------------------------------------- */
  function initDeco() {
    /* v2: además de los [data-deco] de sección, INYECTA colgantes desde
       window.NUVO_DECO (snippets/nuvo-deco-config.liquid, por tienda).
       Cada entrada: { sel, img, x:'left:12%'|'right:8px', top:'100%'|'0px'|'-74px',
       w:px, str:px (cuerdecita), showM/showD:bool }. El molde no pinta nada:
       sin config no hay colgantes. */
    var cfg = window.NUVO_DECO;
    if (cfg && cfg.length) {
      cfg.forEach(function (c) {
        try {
          var host = document.querySelector(c.sel);
          if (!host || !c.img) return;
          if (getComputedStyle(host).position === 'static') { host.style.position = 'relative'; }
          var slot = document.createElement('span');
          slot.className = 'nuvo-hang' + (c.showM === false ? ' nuvo-hang--d' : '') + (c.showD === false ? ' nuvo-hang--m' : '');
          slot.setAttribute('data-deco', '');
          slot.setAttribute('aria-hidden', 'true');
          var xm = /^(left|right):(.+)$/.exec(c.x || 'left:10%');
          slot.style[xm ? xm[1] : 'left'] = xm ? xm[2] : '10%';
          slot.style.top = c.top || '100%';
          slot.style.setProperty('--hw', (c.w || 72) + 'px');
          slot.style.setProperty('--hstr', (c.str || 32) + 'px');
          var item = document.createElement('span');
          item.className = 'nuvo-hang__item';
          item.style.animationDuration = (3.8 + Math.random() * 1.8).toFixed(2) + 's';
          item.style.animationDelay = (Math.random() * 1.2).toFixed(2) + 's';
          var str = document.createElement('span'); str.className = 'nuvo-hang__str';
          var img = document.createElement('img');
          img.src = c.img; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          item.appendChild(str); item.appendChild(img);
          slot.appendChild(item); host.appendChild(slot);
        } catch (e) { /* un colgante mal configurado no tumba el resto */ }
      });
    }
    var els = document.querySelectorAll('[data-deco]');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------
     🛡 Protección de envío en el CARRITO (14/08)
     La línea-recibo con checkbox vive en snippets/cart-drawer.liquid.
     El cajón se repinta ENTERO en cada cambio (Section Rendering de
     Dawn) → los listeners van DELEGADOS en document, no en el nodo.
     La cantidad va SIEMPRE en absoluto por /cart/update.js (1/0).
  ------------------------------------------------------- */
  function initCartProt() {
    function renderProtSections(state) {
      if (!state || !state.sections) { return; }
      var doc;
      if (state.sections['cart-drawer']) {
        doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        var inner = document.querySelector('cart-drawer .drawer__inner');
        var freshInner = doc.querySelector('.drawer__inner');
        if (inner && freshInner) { inner.innerHTML = freshInner.innerHTML; }
        var dw = document.querySelector('cart-drawer');
        if (dw) { dw.classList.toggle('is-empty', state.item_count === 0); }
      }
      if (state.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var d2 = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
        var f2 = d2.querySelector('.shopify-section');
        if (bubble && f2) { bubble.innerHTML = f2.innerHTML; }
      }
    }

    function protUpdate(variantId, qty) {
      var body = {
        updates: {},
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };
      /* v1.3g: un id y su cantidad, o un objeto {id: cantidad} para varios a la vez */
      if (typeof variantId === 'object') { body.updates = variantId; } else { body.updates[variantId] = qty; }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) { throw new Error('cart/update ' + r.status); }
        return r.json();
      }).then(renderProtSections);
    }

    /* Toggle de la línea del recibo (delegado: sobrevive a cada repintado) */
    document.addEventListener('change', function (e) {
      var box = e.target.closest ? e.target.closest('[data-cart-prot-check]') : null;
      if (!box) { return; }
      var id = box.getAttribute('data-prot-id');
      if (!id) { return; }
      var wanted = box.checked;
      box.disabled = true;   /* el repintado trae la casilla fresca; si falla, se revierte */
      protUpdate(id, wanted ? 1 : 0).catch(function () {
        box.disabled = false;
        box.checked = !wanted;
      });
    });

    /* Carrito huérfano: si al quitar el último producto solo queda la protección,
       el marcador [data-prot-orphan] del snippet aparece en el repintado y aquí
       se limpia sola (un envío que ya no existe no se puede proteger). */
    var orphanBusy = false;
    function sweepOrphan() {
      if (orphanBusy) { return; }
      /* v1.3g: la protección y el envío prioritario se van los dos (un envío que ya no
         existe ni se protege ni se adelanta) */
      var orphans = document.querySelectorAll('[data-prot-orphan]');
      if (!orphans.length) { return; }
      var fuera = {};
      Array.prototype.forEach.call(orphans, function (o) { fuera[o.getAttribute('data-prot-id')] = 0; });
      orphanBusy = true;
      protUpdate(fuera)
        .catch(function () {})
        .then(function () { orphanBusy = false; });
    }
    var dwEl = document.querySelector('cart-drawer');
    if (dwEl && 'MutationObserver' in window) {
      new MutationObserver(sweepOrphan).observe(dwEl, { childList: true, subtree: true });
    }
    sweepOrphan();   /* por si ya llega huérfano del servidor */
  }

  ready(function () {
    initProduct();
    initSocialProof();
    initVideos();
    initSlogan();
    initUniverse();
    initReviews();
    initFooterWordmark();
    initReveals();
    initCountUp();
    initCursorGlow();
    initHeader();
    initParallax();
    initHeroImageParallax();
    initStickyAtcDedupe();
    initCartProt();
    initCartPulse();
    initStickyHeader();
    initPerfPausing();
    initDeco();
  });
})();
